module.exports = __webpack_public_path__ + "img/xander-1-empatico.4d5daf19.png";